export default class Currency {
    static format(amount) {
        return (Math.round(amount * 100) / 100).toLocaleString('pl', {
            style: 'currency',
            currency: 'PLN',
        });
    }
}
